import React, { Component } from "react";
import { Sticky, Transition } from "semantic-ui-react";
import menuBtnImage from "../../semantic/dist/themes/fibrestream/assets/images/hamburger.svg";
import menuBtnClose from "../../semantic/dist/themes/fibrestream/assets/images/menu-close.svg";
import Message from './message/Message';

class DefaultHeader extends Component {

  constructor(props) {
    super(props);
    this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    this.state = {
      headerBg: false,
      windowWidth: null,
      isMessageVisible: true
    };
    this.getWidth = this.getWidth.bind(this);
    this.onClose = this.onClose.bind(this);
  }
  componentDidMount() {
    if (this.isChrome) {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
    else {
      this.setState({
        windowWidth: document.documentElement.clientWidth
      });
    }

    window.addEventListener('resize', this.getWidth, false);
  }

  getWidth() {
    if (this.isChrome) {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
    else {
      this.setState({
        windowWidth: document.documentElement.clientWidth
      });
    }
  }

  onClose() {
    this.setState({
      isMessageVisible: false
    });
    setTimeout(() => {
      this.props.measureHeight();
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getWidth, false);
  }

  render() {
    const { windowWidth, isMessageVisible } = this.state;
    return <div className="ui inverted vertical segment py-0">
      {isMessageVisible && <Message onClose={this.onClose} />}
      <Sticky id="stick_header" context={this.props.stickyContext} className="sticky-header-container" onTop={this.stickHeader} >
        <div className="sticky-nav">
          <div className="ui grid mobile only menu--xs">
            <div className="hamburger cursor-pointer" ref={this.props.toggleContainer} onClick={this.props.toggleMobileMenu}>
              <img
                src={this.props.mobileMenuSwitch ? menuBtnClose : menuBtnImage}
                alt="Navigation"
                width="52"
                height="32"
              />
            </div>
          </div>
          <div className={this.props.mobileMenuSwitch ? 'nav xs-block' : 'nav'}>
            <div className="ui container">
              {windowWidth >= 768 && <div className="ui grid row">
                <div className="fourteen wide column pr-0 py-0">
                  {this.props.getMenu()}
                </div>
                <div className="two wide column py-0">
                  <div className="ui text menu">
                    {this.props.getSignupMenu()}
                  </div>
                </div>
              </div>
              }

              {windowWidth <= 767 &&

                <div>
                  <Transition mountOnShow={false} visible={this.props.mobileMenuSwitch} animation="slide down" duration={500}>
                    {this.props.getMenu()}
                  </Transition>
                  {this.props.getSignupMenu()}
                </div>
              }
            </div>
          </div>
        </div>
      </Sticky>
    </div >
  }

};

export default DefaultHeader;


// WEBPACK FOOTER //
// ./src/components/header/DefaultHeader.js